import { SweepNotificationVariant } from '../../../../../reducers/notificationsReducer';
import { useSweepNotifications } from '../../../../notifications/useSweepNotifications';
import { isMetadataElementInCanvas } from './helper';
import { useAddMetadataElementToCanvas } from '../../metadata-elements/useAddMetadataElementToCanvas';
import { useCallback } from 'react';
import { useDocumentationContext } from '../../../../documentation/context/DocumentationContext';

export const useAddToCanvas = () => {
  const { addNotification } = useSweepNotifications();
  const { addMetadataElementsToCanvasAndEnrichConnections } = useAddMetadataElementToCanvas();
  const { canvasFunnelMap } = useDocumentationContext();

  const onAddToCanvas = useCallback(
    async ({
      element,
      crmOrgId,
      callback,
    }: {
      element: {
        metadataId?: string;
        label?: string;
        parentType?: string;
        dependencyType?: string;
      };
      crmOrgId: string;
      callback?: () => void;
    }) => {
      if (!element.metadataId || !element.label || !element.parentType || !canvasFunnelMap) {
        // We don't want to break the funnel map by adding invalid data.
        // Will be much harder to fix it.
        addNotification({
          message: 'Metadata element is missing required fields',
          variant: SweepNotificationVariant.Error,
          keepOpen: true,
        });
        return;
      }

      const isAlreadyInCanvas = isMetadataElementInCanvas({
        crmOrgId,
        metadataId: element.metadataId,
        canvasFunnelMap,
      });
      if (isAlreadyInCanvas) {
        return;
      }

      const metadataElement = {
        name: element.label,
        metadataId: element.metadataId,
        type: element.dependencyType || element.parentType,
        crmOrgId,
        parentType: element.parentType,
      };

      await addMetadataElementsToCanvasAndEnrichConnections({
        metadataElements: [metadataElement],
        canvasFunnelMap,
      });
      callback?.();
    },
    [addMetadataElementsToCanvasAndEnrichConnections, addNotification, canvasFunnelMap],
  );

  return onAddToCanvas;
};
